<template>
  <v-app light>
    <v-toolbar color="#f5f5f5" light app>
      <!-- <v-icon @click.stop="drawer = !drawer" class="hidden-lg-and-up">bar</v-icon> -->
      <v-toolbar-side-icon
        class="hidden-lg-and-up"
        @click.stop="drawer = !drawer"
      ></v-toolbar-side-icon>
      <v-toolbar-title class="primary--text">COMUNA LUPȘA</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <div class="primary--text">
        <v-breadcrumbs :items="crumbs" divider="/" dark>
          <template v-slot:item="props">
            <v-breadcrumbs-item>
              <a
                :class="[props.item.disabled && 'disabled']"
                class="primary--text"
                :href="props.item.href"
                >{{ props.item.text }}</a
              >
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </div> -->
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="isLoggedIn && user != null && user.username != null"
            color="#ea6d00"
            depressed
            class="white--text"
            v-on="on"
            >{{ user.username }}</v-btn
          >
        </template>
        <v-list>
          <v-list-tile @click="$router.push('/profile/update-password')">
            <v-list-tile-title>Schimbare Parola</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="logout">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-navigation-drawer v-model="drawer" app :width="340">
      <v-img
        src="https://blockchain-engineering.tech/wp-content/uploads/2020/05/Registre.ro_.png"
        @click="$router.push('/')"
      ></v-img>
      <v-layout row style="width: auto;display: block;">
        <v-flex>
          <v-card>
            <v-list subheader>
              <div v-for="entity in entities" :key="entity.id">
                <div v-if="entity.subheader">
                  <v-divider />
                  <v-subheader>{{ entity.subheader }}</v-subheader>
                </div>
                <v-list-group
                  class="post"
                  subheader
                  :prepend-icon="entity.icon"
                >
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-title>{{
                        entity !== null ? entity.title : ''
                      }}</v-list-tile-title>
                    </v-list-tile>
                  </template>

                  <v-list-tile
                    v-for="(form, index) in entity.forms"
                    v-show="form.key !== 'ref'"
                    :key="index"
                    style="width: auto;display: block;"
                    class="post"
                    @click="redirectToForm(form, entity)"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title class="meniust">{{
                        form !== null ? form.title : ''
                      }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list-group>
              </div>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-navigation-drawer>
    <v-content>
      <v-container fluid>
        <notifications group="notifications" />
        <router-view
          :key="updates"
          @getTitleCrudForm="getTitleCrudForm"
          @getTitleFormView="getTitleFormView"
          @destroyedCrudForm="destroyedCrudForm"
          @destroyedFormView="destroyedFormView"
          @emptyFormView="emptyFormView"
          @getMapTitle="getMapTitle"
          @destroyedMap="destroyedMap"
        ></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import store from '../store'
import ApiService from '../lib/rd-forms/APIService'

export default {
  name: 'HomePage',
  data() {
    return {
      entities: [],
      drawer: null,
      items: [
        {
          action: 'lock',
          title: 'Login',
          destination: '/login'
        }
      ],
      updates: 0,
      form: null,
      entity: null,
      crumbs: [{ disabled: false, text: 'Homepage', exact: true, href: '/' }],
      titleCrud: null,
      receivedEmptyForm: false
    }
  },
  computed: {
    isLoggedIn: function() {
      return store.getters.isLoggedIn
    },
    user: function() {
      return store.getters.user
    },
    getCurrentPath() {
      return this.$route.path
    }
  },
  created() {
    ApiService.getAllEntities()
      .then((res) => {
        // order the entities
        console.log(
          'Starting entities processing... ' + new Date().toISOString()
        )
        res.data.sort((a, b) => {
          if (a.orderIndex == null && b.orderIndex == null)
            return this.compareStrings(a.title, b.title)
          if (a.orderIndex == null) return -1
          if (b.orderIndex == null) return 1
          return a.orderIndex - b.orderIndex
        })
        // process and order each entity's forms
        res.data.forEach((entity) => {
          this.processForms(entity)
        })
        this.entities = res.data
        console.log(
          'Finished entities processing... ' + new Date().toISOString()
        )
        console.log(this.entities)
      })
      .catch(function(error) {
        console.log('Error fetching entities', error)
      })
  },
  methods: {
    getMapTitle(value) {
      this.crumbs.push({
        text: value != null ? value : 'Hartă',
        disabled: true
      })
    },
    getTitleFormView(value) {
      this.crumbs.push({
        text: value != null ? value : 'Listare',
        disabled: false,
        href: this.$route.path
      })
      this.receivedEmptyForm = false
    },
    getTitleCrudForm(value) {
      if (this.crumbs.length == 1)
        this.crumbs.push({
          text: value != null ? value : 'Adaugare',
          disabled: true
        })
      else if (this.crumbs.length == 2) {
        if (value) {
          value = value.split(' ')
          value[0] = 'Editare'
          value = value.join(' ')
        }
        this.crumbs.push({
          text: value != null ? value : 'Editare',
          disabled: true
        })
      }
    },
    emptyFormView() {
      console.log('Empty list form mounted')
    },
    destroyedFormView() {
      this.crumbs.pop()
    },
    destroyedCrudForm() {
      this.crumbs.pop()
    },
    destroyedMap() {
      this.crumbs.pop()
    },
    schimba(next) {
      if (next != undefined) this.$router.push(next) //could update router here
    },
    logout: function() {
      store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    },
    redirectToForm(form, entity) {
      if (form == null) {
        return
      }
      this.updates++
      if (form.key.startsWith('redirect-')) {
        window.open(form.specs.url, '_blank')
      } else {
        this.$router.push({
          name: 'FormView',
          params: {
            formType: form.key,
            entityId: entity.id
          }
        })
      }
    },
    compareStrings(str1, str2) {
      if (str1 < str2) return -1
      if (str1 > str2) return 1
      return 0
    },
    /**
     * Transforms an entity's forms to an array from an object.
     * The array is sorted using the form's order index and a default rule.
     * E.g.:
     * entity: {
     *    collectionName: 'sondaje',
     *    forms: {
     *        crud: {
     *        },
     *        list: {
     *        }
     *    }
     * }
     * --> to
     * entity: {
     *    collectionName: 'sondaje',
     *    forms: [
     *      {
     *        key: 'crud'
     *        ...
     *      },
     *      {
     *        key: 'list'
     *        ...
     *      }
     *    ]
     * }
     */
    processForms(entity) {
      // extract obj elements to array
      const objForms = JSON.parse(JSON.stringify(entity.forms))
      const arrForms = []
      Object.keys(objForms).forEach((key) => {
        arrForms.push(objForms[key])
      })
      // sort the forms
      const FORM_TYPES_DEFAULT_SORT = [
        'CRUD',
        'LIST',
        'CAL',
        'MAP',
		'CHARTS',
        'IFRAME',
        'REDIRECT'
      ]
      arrForms.sort((f1, f2) => {
        // get the specified order's indexes
        const f1OrderIndex =
          f1.specs != null && f1.specs.orderIndex != null
            ? f1.specs.orderIndex
            : null
        const f2OrderIndex =
          f2.specs != null && f2.specs.orderIndex != null
            ? f2.specs.orderIndex
            : null
        const f1Type = this.getFormTypeFromKey(f1.key)
        const f2Type = this.getFormTypeFromKey(f2.key)

        if (f1OrderIndex == null && f2OrderIndex == null) {
          // compare the types
          if (f1Type === f2Type) {
            return this.compareStrings(f1.key, f2.key)
          }
          return (
            FORM_TYPES_DEFAULT_SORT.indexOf(f1Type.toUpperCase()) -
            FORM_TYPES_DEFAULT_SORT.indexOf(f2Type.toUpperCase())
          )
        }

        if (f1OrderIndex == null) return -1
        if (f2OrderIndex == null) return 1
        return f1OrderIndex - f2OrderIndex
      })
      entity.forms = arrForms
    },
    /**
     * E.g.
     * iframe-5eb94826ce269d65b7166eb6  -> iframe
     * crud                             -> crud
     */
    getFormTypeFromKey(key) {
      return key.includes('-') ? key.substring(0, key.indexOf('-')) : key
    }
  }
}
</script>

<style scoped>
.meniust {
  color: #ea6d00;
}
.v-breadcrumbs__item {
  color: whitesmoke !important;
}

a:link {
  color: white;
}
</style>
